var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalisman({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.04 46c0 3.2905 2.6487 5.9623 5.9303 5.9996 3.2816-.0373 5.9303-2.7091 5.9303-5.9996 0-3.2904-2.6487-5.9623-5.9303-5.9996-3.2816.0373-5.9303 2.7092-5.9303 5.9996z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.8544 35.6623c-.6082 1.3245-2.3991 1.7923-3.4296.7618l-1.88921-1.8892c-1.95264-1.9526-5.11848-1.9526-7.07111 0-1.952639 1.9526-1.952639 5.1185 0 7.0711l15.27462 15.2747c3.6551 4.3369 9.1204 7.0981 15.2312 7.1187 6.1108-.0206 11.5761-2.7818 15.2311-7.1187l15.2747-15.2747c1.9526-1.9526 1.9526-5.1185 0-7.0711-1.9527-1.9526-5.1185-1.9526-7.0712 0l-1.8891 1.8892c-1.0306 1.0305-2.8215.5627-3.4297-.7618-.1198-.261-.1851-.541-.1851-.8282v-22.8346c0-2.7614-2.2386-4.99998-5-4.99998s-5 2.23859-5 4.99998v11.5573c0 .9938-1.0181 1.6684-1.9657 1.3689-.5997-.1896-1.033-.7356-1.033-1.3646v-18.56154c0-2.73874-2.2019-4.9631907-4.932-4.99956-2.7301.0363693-4.9321 2.26082-4.9321 4.99956v18.56154c0 .629-.4332 1.175-1.033 1.3646-.9476.2995-1.9657-.3751-1.9657-1.3689l.0001-11.5573c0-2.76139-2.2386-4.99998-5.0001-4.99998-2.7614 0-5 2.23858-5 4.99998v22.8346c0 .2872-.0652.5672-.1851.8282zm18.1159.3376c-8.8044.0526-15.93 9.9998-15.93 9.9998s7.1256 9.9472 15.93 9.9998c8.8043-.0526 15.9299-9.9998 15.9299-9.9998s-7.1256-9.9472-15.9299-9.9998z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalisman);
export default __webpack_public_path__ + "static/media/talisman.9eb31bb23ab6ae423585d9af7bb1aedc.svg";
export { ForwardRef as ReactComponent };